export function isValidShippingDetails(values) {
  const isValidPrimaryData =
    values.shippingType &&
    values.recipientName &&
    values.recipientEmail &&
    values.recipientPhoneNumber;
  if (!isValidPrimaryData) {
    return false;
  }
  if (values.shippingType === 'locker') {
    return !!(
      values.locker &&
      values.selectedLocker &&
      values.selectedLocker.label &&
      values.selectedLocker.value
    );
  } else if (values.shippingType === 'door') {
    return !!(
      values.addressType &&
      values.location &&
      values.location.selectedPlace &&
      values.location.selectedPlace.address &&
      values.location.selectedPlace.origin &&
      typeof values.location.selectedPlace.origin.lat === 'number' &&
      typeof values.location.selectedPlace.origin.lng === 'number'
    );
  }
  return false;
}
